import styled, { css, keyframes } from 'styled-components';
export var DURATION = 300;
var getExpandAnimation = function getExpandAnimation(height, textMargin) {
  return keyframes(["from{opacity:0;margin-top:0;height:0;}to{opacity:1;height:", "px;margin-top:", "px;}"], height, textMargin);
};
var getCollapseAnimation = function getCollapseAnimation(height, textMargin) {
  return keyframes(["from{opacity:1;height:", "px;margin-top:", "px;}to{opacity:0;margin-top:0;height:0;}"], height, textMargin);
};
export var Fade = styled.div.withConfig({
  displayName: "animation__Fade",
  componentId: "sc-1e0ys07-0"
})(["", ""], function (_ref) {
  var state = _ref.state,
    height = _ref.height,
    textMargin = _ref.textMargin;
  var expandAnimation = getExpandAnimation(height, textMargin);
  var collapseAnimation = getCollapseAnimation(height, textMargin);
  switch (state) {
    case 'entering':
      return css(["animation:", " ease-in ", "ms;"], expandAnimation, DURATION);
    case 'entered':
      return css(["opacity:1;margin-top:", "px;"], textMargin);
    case 'exiting':
      return css(["animation:", " ease-out ", "ms;"], collapseAnimation, DURATION);
    case 'exited':
      return css(["opacity:0;"]);
  }
});